var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-content\">\n<div class=\"modal-header\">\n</div>\n<div class=\"modal-body text-center\">\n<p>{{message}}</p>\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\" translate=\"PUBLIC_BOOKING.ERROR_MODAL.OK_BTN\">\n</button>\n</div>\n</div>\n";
var id1="public-booking/services/error_modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/public-booking/services/error_modal.html
// module id = 506
// module chunks = 0